import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ForgeEditInterface } from "../../../middleware/interfaces/forge/forge-edit-interface";

export const ForgeEdit = {
  Edit: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const forgeEditData: ForgeEditInterface = state.data;
      const url = "./php/forge/forge-editor-proxy.php";
      await axios
        .post(url, forgeEditData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
